import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import { Button, PageHeader } from '../components'
import { TextInput } from '../components/fields'
import { clearFlashMessage } from '../../common/app/actions'

class StudentLandingPage extends React.Component {
  state = {
    task: null,
    number: '',
    err: '',
  }

  setTask = (task) => this.setState({ task, err: '' })
  setNumber = (number) => this.setState({ number, err: '' })

  checkNumber(e) {
    const { number } = this.state
    const { intl, clearFlashMessage } = this.props

    if (!number || number.length < 5) {
      e.preventDefault()
      this.setState({
        err: intl.formatMessage(messages.urlError)
      })
    }

    clearFlashMessage()
  }

  render() {
    const { intl } = this.props
    const { task, number, err } = this.state

    return (
      <div className="welcome-page flex-column items-center">
        <PageHeader
          center
          title={intl.formatMessage(messages.welcomeMsg)}
        />
        <div className="spacing-top flex-column items-center">
          <div>
            <Button
              big
              positive={task == 'test'}
              onClick={() => this.setTask('test')}
            >
              {intl.formatMessage(messages.fillTest)}
            </Button>
          </div>
          <p>{intl.formatMessage(messages.or)}</p>
          <div>
            <Button
              big
              positive={task == 'homework'}
              onClick={() => this.setTask('homework')}
            >
              {intl.formatMessage(messages.fillHomework)}
            </Button>
          </div>
        </div>
        {
          task &&
          <div className="spacing-top flex-column-center">
            <p>vobo.io/{task}/{number}</p>
            <TextInput
              value={number}
              onChange={(e) => this.setNumber(e.target.value)}
              label={intl.formatMessage(messages.addressLabel)}
              placeholder="12345"
            />
            <Link
              to={`/${task}/${number}`}
              onClick={e => this.checkNumber(e)}
            >
              <Button positive>
                {intl.formatMessage(messages.continue)}
              </Button>
            </Link>
            {
              err && <p className="red-text">{err}</p>
            }
          </div>
        }
      </div>
    )
  }
  
}

StudentLandingPage.propTypes = {
  intl: PropTypes.object.isRequired,
}


const enhance = compose(
  connect(() => ({ }), { clearFlashMessage }),
  injectIntl,
)

export default enhance(StudentLandingPage)

const messages = defineMessages({
  welcomeMsg: {
    id: 'welcome.page.welcomeMsg',
    defaultMessage: 'Chcete vyplniť test alebo úlohu?',
  },
  fillTest: {
    id: 'welcome.page.fillTest',
    defaultMessage: 'Vyplniť test',
  },
  or: {
    id: 'welcome.page.or',
    defaultMessage: 'alebo',
  },
  fillHomework: {
    id: 'welcome.page.fillHomework',
    defaultMessage: 'Vyplniť úlohu',
  },
  addressLabel: {
    id: 'welcome.page.addressLabel',
    defaultMessage: 'Zadaj číslo (5 cifier) úlohy alebo testu:',
  },
  continue: {
    id: 'welcome.page.continue',
    defaultMessage: 'Pokračovať',
  },
  urlError: {
    id: 'welcome.page.urlError',
    defaultMessage: 'Nezadal si 5 ciferné číslo',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/StudentLandingPage.js